import clsx from 'clsx';
import { Anchor } from 'components/atoms';
import React from 'react';

import css from '../Startseite.module.scss';

const partners = [
  {
    name: 'H. Ploberger GmbH',
    logo: '/static/images/partners/ploberger.svg',
    url: 'https://www.ploberger.cc/',
  },
  {
    name: 'M-I Immobilien GmbH',
    logo: '/static/images/partners/mi-immobilien.svg',
    url: 'https://www.m-i.cc/vermietung/',
  },
  {
    name: 'unternehmen24 e.U.',
    logo: '/static/images/partners/unternehmen24.svg',
    url: 'https://www.unternehmen24.info/',
  },
  {
    name: 'DIHAM Capital Management & Consulting GmbH',
    logo: '/static/images/partners/diham.svg',
    url: 'https://diham.net/',
  },
];

const Partners: React.FC = () => (
  <section className={clsx(css.section, css.partners)}>
    <h2>Diese Unternehmen setzen auf wirtschaft.at</h2>
    <div className={css.partnerLogos}>
      {partners.map((partner) => (
        <a
          key={partner.name}
          href={partner.url}
          target="_blank"
          rel="noopener noreferrer"
          className={css.partnerLogoLink}
          title={partner.name}
        >
          <img
            src={partner.logo}
            alt={partner.name}
            className={css.partnerLogo}
            height={100}
            loading={'lazy'}
          />
        </a>
      ))}
    </div>
    <div className={css.partnerCta}>
      <Anchor as="button" href="/produkte">
        Schließen Sie sich ihnen an
      </Anchor>
    </div>
  </section>
);

export default Partners;